import React from 'react';
import { SideBarModal } from '@/components/Modal';
import { Button } from '@/components';

interface SettleIdleCostConfirmModalProps {
  isOpen: boolean;
  oemName: string;
  // 'settle' stops idle cost for every current unit of the OEM;
  // 'resume' clears the mark so idle cost accrues again.
  mode: 'settle' | 'resume';
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const SettleIdleCostConfirmModal: React.FC<SettleIdleCostConfirmModalProps> = ({
  isOpen,
  oemName,
  mode,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  const isSettle = mode === 'settle';

  return (
    <SideBarModal
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      width="md"
      maxHeight="auto"
      showCloseButton={false}
      header={
        <div className="flex items-start gap-4">
          <div
            className={`flex h-[40px] w-[50px] items-center justify-center rounded-lg ${
              isSettle
                ? 'bg-emerald-50 text-emerald-500'
                : 'bg-orange-50 text-orange-500'
            }`}
          >
            <i
              className={`${
                isSettle ? 'ri-money-dollar-circle-fill' : 'ri-refresh-fill'
              } text-[16px]`}
            />
          </div>
          <div>
            <div className="text-xl font-semibold text-gray-900">
              {isSettle
                ? `Settle idle cost for ${oemName}?`
                : `Resume idle cost for ${oemName}?`}
            </div>
            <div className="mt-1 text-sm text-gray-500">
              {isSettle
                ? `All current ${oemName} units will stop accruing idle cost (the OEM deal is paid off). Idle days keep counting, and units added later will still accrue normally.`
                : `All ${oemName} units marked as settled will start accruing idle cost again.`}
            </div>
          </div>
        </div>
      }
      footer={
        <div className="flex w-full justify-end gap-2">
          <Button
            onClick={onClose}
            className="rounded-xl border border-gray-200 bg-white px-6 py-2 text-gray-600 hover:bg-gray-50"
            variant={'secondary'}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isSubmitting}
            className="rounded-xl px-6 py-2 text-white"
            variant={'primary'}
          >
            {isSubmitting
              ? 'Saving...'
              : isSettle
                ? 'Settle Idle Cost'
                : 'Resume Idle Cost'}
          </Button>
        </div>
      }
    >
      <div className="h-0" />
    </SideBarModal>
  );
};

export default SettleIdleCostConfirmModal;
